import { createAsyncAction } from "../utils/actionCreators";

export const types = {
  BAIXAR_ARTEFATO: "@@documentos/BAIXAR_ARTEFATO",
};

export const actions = {
  baixarArtefato: createAsyncAction(types.BAIXAR_ARTEFATO),
};
